<template>
  <div class="welcome">
    <el-form ref="addForm" :model="addForm" label-width="120px">
      <el-form-item label="工号" class="workNumer">
        <el-input size="small" v-model="addForm.workNumer" placeholder="请输入工号" clearable></el-input>
      </el-form-item>
      <el-form-item label="手机号你" class="phone">
        <el-input size="small" v-model="addForm.phone" placeholder="请输入工号" clearable></el-input>
      </el-form-item>
      <el-form-item class="btn">
        <el-button type="primary" size="small" class="search" @click="bindNewEmployee">入职绑定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'welcome',
  data() {
    return {
      imgList: [],
      input: '',
      addForm: {
        workNumer: this.$route.params.id || '',
        phone: this.$route.params.phone || ''
      }
    }
  },
  mounted() {
    if (this.$route.params.id && this.$route.params.phone && this.$route.params.code) {
      this.bindNewEmployee()
    }
    console.log('scan')
    setTimeout(() => {
      if (this.is_weixn()) {
        this.sign()
      }
      // this.sign2()
    }, 1000)
    // this.sign2()
    // const city = []
    // const data = cityData[0].children
    // console.log(data)
    // for (let i = 0; i < data.length; i++) {
    //   city.push({
    //     value: data[i].value,
    //     label: data[i].value
    //   })
    //   if (data[i].children) {
    //     city[i].children = []
    //     for (let j = 0; j < data[i].children.length; j++) {
    //       city[i].children.push({
    //         value: data[i].children[j].value,
    //         label: data[i].children[j].value
    //       })
    //       if (data[i].children[j].children) {
    //         city[i].children[j].children = []
    //         for (let k = 0; k < data[i].children[j].children.length; k++) {
    //           city[i].children[j].children.push({
    //             value: data[i].children[j].children[k].value,
    //             label: data[i].children[j].children[k].value
    //           })
    //         }
    //       }
    //     }
    //   }
    // }
    // console.log(this.$common.jsonStr(city))
    // this.$common.storage.set('city', city)
  },
  methods: {
    is_weixn() {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    // 解析页面URL
    scanClick() {
      this.bindNewEmployee()
      // this.sign()
      // this.sign2()
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          console.log(result)
          this.bindNewEmployee()
        }
      })
    },
    sign2() {
      var data = {
        url: window.location.href.split('#')[0]
      }

      $.post('http://218.4.111.162:9175/weixin/Sign', data, function(data) {
        wx.config({
          debug: false,
          appId: data.appid,
          timestamp: data.timestamp,
          nonceStr: data.noncestr,
          signature: data.signature,
          jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'scanQRCode']
        })
      })
    },
    // sign2() {
    //   var data = {
    //     url: window.location.href.split('#')[0]
    //   }
    //   this.$formUrlencoded2('/api/weixin/Sign', data).then(result => {
    //     console.log(result)
    //     wx.config({
    //       debug: false,
    //       appId: result.appid,
    //       timestamp: result.timestamp,
    //       nonceStr: result.noncestr,
    //       signature: result.signature,
    //       jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'scanQRCode']
    //     })
    //   })
    // },
    sign() {
      const param = {
        // cid: this.$route.params.id,
        cid: '1',
        url: window.location.href.split('#')[0]
      }
      console.log(param)
      this.$post('/wechat/sign', param).then(
        result => {
          if (result.status === 200) {
            wx.config({
              debug: false,
              // appId: 'wx3eb7e979c4024c83',
              // appId: 'wx5d4de6267db6f700', // 联众
              appId: 'wx66b5ace206eaded0', // 联众
              timestamp: result.data.timestamp,
              nonceStr: result.data.nonceStr,
              signature: result.data.signature,
              jsApiList: ['scanQRCode']
            })
            wx.ready(function() {
              console.log(result)
            })
            wx.error(res => {
              console.log(res)
              this.$dialog.alert({
                message: '微信授权失败!' + res.errMsg
              })
            })
          } else {
            this.$dialog.alert({
              message: result.msg
            })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.message
          })
        }
      )
    },
    // 入职绑定
    bindNewEmployee() {
      if (!this.addForm.workNumer) {
        return this.$toast('请填写账户')
      }
      if (!this.addForm.phone) {
        return this.$toast('请填写账户手机号码')
      }
      if (!this.$route.params.code) {
        window.location.href =
          './?wechatLogin=true&targetName=Scan&id=' +
          this.addForm.workNumer +
          '&phone=' +
          this.addForm.phone +
          '&state=111'
        return
      }
      const param = {
        id: 1,
        workNumer: this.addForm.workNumer,
        phone: this.addForm.phone,
        code: this.$route.params.code
      }
      this.$get('/user/bindNewEmployee', param).then(
        result => {
          if (result.status === 200) {
            this.$toast(result.msg)
          } else {
            if (result.msg === '获取openid失败') {
              window.location.href =
                './?wechatLogin=true&targetName=Scan&id=' +
                this.addForm.workNumer +
                '&phone=' +
                this.addForm.phone +
                '&state=111'
            }
            this.$dialog.alert({
              message: result.msg
            })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    }
  },
  destroyed() {}
}
</script>

<style lang="less" scoped>
.welcome {
  padding: 5vw;
  box-sizing: border-box;
  .img-box {
    display: flex;
    flex-wrap: wrap;
    .img {
      img {
        max-width: 200px;
      }
    }
  }
  .scan-icon {
    padding-top: calc(50vh - 20vw);
    text-align: center;
    color: #10a60e;
    /deep/.van-icon-scan {
      font-size: 30vw;
    }
  }
}
</style>
